import { RouteOptionsById, router, RouterIds } from "@vixi/router";
import { AuthPageLayout } from "@vixi/ui";

const routeId = "/_auth" satisfies RouterIds;
const _Route = router.routesById[routeId];

export const AuthRouteOptions: RouteOptionsById<typeof routeId> = {
  component: AuthPageLayout,
};
